//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 
import {get,post} from '../api'
export default {
    mounted() {
      // this.xnTags=["N25","N28","N30"];
      // this.radioXN=this.xnTags[0];
      this.getAutoHeight();
      const self=this;
      window.onresize=function(){
        self.getAutoHeight();
      };
      this.lxTags=["毛坯","成品"];
      // this.radioLX=this.lxTags[0];
      // console.log(this.$equipment());
      this.getXN(this.checkLX);
      this.onSearch();
    },
    watch: {
      'searchQuery': {
        handler(newValue, oldValue) {
          // console.log(`searchQuery from ${oldValue} to ${newValue}`);
          // console.log(`searchQuery value ${this.searchQuery}`);
          // this.onSearch();
        },
        deep: true
      },
      'checkXN': {
        handler(newValue, oldValue) {
          // console.log(`checkXN from ${oldValue} to ${newValue}`);
          // this.currentXN=newValue;
          this.onSearch(1);
        },
        deep: true
      },
      'checkLX': {
        handler(newValue, oldValue) {
          // console.log(`checkLX from ${oldValue} to ${newValue}`);
          // this.currentLX=newValue;
          this.checkXN=[];
          this.MPInfo=this.CPInfo=[];
          this.checkAll=true;
          this.getXN(this.checkLX);
          this.onSearch(1);
        },
        deep: true
      }
    },
    methods: {
      checkChange(){
        // console.log('checkAll',this.checkAll);
        if(this.checkAll==true){
          this.checkXN=this.xnTags;
        }
        else{
          this.checkXN=[];
        }
      },
      onSearch (pageindex){
        if(pageindex!==undefined){
          this.pageIndex=pageindex;
        }
        // // 这里只是简单地模拟搜索，实际应用中需要发起网络请求
        // this.results = [{title:'标题一',content:'结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1结果1'}, 
        // {title:'标题二',content:'结果2'}, 
        // {title:'标题三',content:'结果3'}].filter(
        //   (result) => result.title.includes(this.searchQuery)||result.content.includes(this.searchQuery)
        // );
        // console.log("this.$equipment()",this.$equipment()===null);
        // console.log("this.checLX",this.checLX=="成品");
        if(this.checkXN.length==0){
          this.checkXN=["00"];
        }

        if(this.checkLX=="成品"){
          post('/CPInfo/Query', {XN:this.checkXN.join(','),keyFilter:this.searchQuery,pageindex:this.pageIndex,pagesize:6}).then(response => {
            // console.log(response);
            if(response.code==1){
              this.CPInfo=response.data||[];
              this.pageCount=response.PageCount;
            }
            else if(response.code==0){
              // this.$message({
              //   message: response.data,
              //   type: 'error'
              // });
              console.log(response.data);
            }
          }).catch(error => {
            console.log(error);
          });
        }
        else if(this.checkLX=="毛坯"){
          post('/MPInfo/Query', {XN:this.checkXN.join(','),keyFilter:this.searchQuery,pageindex:this.pageIndex,pagesize:6}).then(response => {
            console.log(response);
            if(response.code==1){
              this.MPInfo=response.data||[];
              this.pageCount=response.PageCount;
            }
            else if(response.code==0){
              // this.$message({
              //   message: response.data,
              //   type: 'error'
              // });
              console.log(response.data);
            }
          }).catch(error => {
            console.log(error);
          });
        }
      },
      onPreSearch(){
        if(this.pageIndex<=1)return;
        this.pageIndex=this.pageIndex-1;
        this.onSearch();
      },
      onNextSearch(){
        if(this.pageIndex>=this.pageCount)return;
        this.pageIndex=this.pageIndex+1;
        this.onSearch();
      },
      goManager(){
        if(this.$equipment()===null){
          // console.log("产品管理");
          //  this.$router.push({ path: '/ProductPage' });
        }
      },
      getXN(type){
        if(type=="毛坯"){
          get('/SearchCenter/QueryMPXN', {}).then(response => {
              // console.log(response);
              if(response.code==1){
                this.checkXN= this.xnTags=response.data;
              }
              else if(response.code==0){
                // this.$message({
                //   message: response.data,
                //   type: 'error'
                // });
                console.log(response.data);
              }
            }).catch(error => {
              console.log(error);
            });
        }
        else if(type=="成品"){
          get('/SearchCenter/QueryCPXN', {}).then(response => {
              // console.log(response);
              if(response.code==1){
                this.checkXN= this.xnTags=response.data;
              }
              else if(response.code==0){
                // this.$message({
                //   message: response.data,
                //   type: 'error'
                // });
                console.log(response.data);
              }
            }).catch(error => {
              console.log(error);
            });
        }
      },
      getAutoHeight(){
        this.$nextTick(()=>{
          var tag_xn = document.getElementById('tag-xn');
          var tag_xn_height=tag_xn.scrollHeight;
          // console.log("tag_xn height",tag_xn_height);
          this.heightMP = this.heightCP =this.heightMP =(56*6)+"px";
          // console.log("height",this.heightMP);
          // console.log("window.innerHeight",window.innerHeight);
        });
      },
      getStyle(obj,attr){
        // 兼容IE浏览器
        let result = obj.currentstyle?
          obj.currentstyle[attr].replace("px","")
          :document.defaultView.getComputedStyle(obj, null)[attr].replace("px","");
        return Number(result);
      }
    },
    data () {
      return {
        searchQuery:'',
        results:[],
        xnTags:[],
        checkXN:[],
        lxTags:[],
        checkLX:"毛坯",
        MPInfo:[],
        CPInfo:[],
        heightMP:"200px",
        heightCP:"200px",
        pageIndex:1,
        pageCount:0,
        checkAll:true
      }
    },
};



// WEBPACK FOOTER //
// ./src/components/WholeSaleCenter/PC.vue